import { styled } from '@goodfynd/react-web.theme';
import Tabs from '@mui/material/Tabs';

export const StyledTabs = styled(Tabs, {
  variants: {
    position: {
      sticky: {
        backgroundColor: 'var(--BackgroundBase1)',
        height: 64,
        padding: '1rem 0',
        position: 'sticky',
        top: 0,
        zIndex: 10,
      },
    },
  },
});
